/* ==========================================================================
   sales-landing.js — interactions specific to the Sales Landing Page.
   Reveal-on-scroll, FAQ accordion, footer accordion and star rendering
   already come from ../js/main.js (loaded before this file).
   ========================================================================== */
(function () {
  "use strict";

  if (window.__jt5SalesInit) return;
  window.__jt5SalesInit = true;

  /* --------------------------------------------------- Watch showcase panel */
  var track = document.querySelector("[data-panel-track]");
  if (track) {
    var slides = Array.prototype.slice.call(track.querySelectorAll("[data-pos]"));
    var isAnimating = false;
    var ANIM_MS = 650;

    function getByPos(pos) {
      return slides.filter(function (s) { return s.getAttribute("data-pos") === pos; })[0];
    }

    function cycle(dir) {
      if (isAnimating) return;
      isAnimating = true;

      var left = getByPos("left");
      var center = getByPos("center");
      var right = getByPos("right");

      if (dir > 0) {
        /* the outgoing left slide teleports (no transition) past the right
           edge, then animates back in to the right slot so it looks like it
           wrapped around instead of sliding backwards across the center */
        left.classList.add("is-jumping");
        left.setAttribute("data-pos", "far-right");
        void left.offsetWidth; /* flush the jump before re-enabling the transition */
        left.classList.remove("is-jumping");

        left.setAttribute("data-pos", "right");
        center.setAttribute("data-pos", "left");
        right.setAttribute("data-pos", "center");
      } else {
        right.classList.add("is-jumping");
        right.setAttribute("data-pos", "far-left");
        void right.offsetWidth;
        right.classList.remove("is-jumping");

        right.setAttribute("data-pos", "left");
        center.setAttribute("data-pos", "right");
        left.setAttribute("data-pos", "center");
      }

      window.setTimeout(function () { isAnimating = false; }, ANIM_MS);
    }

    var prevBtn = document.querySelector("[data-panel-prev]");
    var nextBtn = document.querySelector("[data-panel-next]");
    if (prevBtn) prevBtn.addEventListener("click", function () { cycle(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { cycle(1); });
  }

  /* ------------------------------------------------------ Feature list (Inside the product) */
  var insideProdTabletQuery = window.matchMedia("(max-width: 1299px)");

  function isInsideProdCompactLayout() {
    return insideProdTabletQuery.matches;
  }

  function getInsideProdScrollOffset() {
    var header = document.querySelector(
      ".t4s-section-header.t4sp-sticky .t4s-header__wrapper, .t4s-section-header, .header-des"
    );

    if (header) {
      var rect = header.getBoundingClientRect();
      if (rect.height > 0) {
        return rect.bottom + 12;
      }
      return header.offsetHeight + 12;
    }

    return 80;
  }

  function scrollFeatureHeadIntoView(head) {
    if (!head || !isInsideProdCompactLayout()) return;

    window.setTimeout(function () {
      var offset = getInsideProdScrollOffset();
      var rect = head.getBoundingClientRect();
      var targetTop = window.scrollY + rect.top - offset;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: "smooth"
      });
    }, 360);
  }

  function initInsideProductFeatures(root) {
    var scope = root || document;

    scope.querySelectorAll(".sl-inside-prod-section [data-feature-head]").forEach(function (head) {
      if (head.dataset.featureHeadInit === "true") return;
      head.dataset.featureHeadInit = "true";

      head.addEventListener("click", function () {
        var section = head.closest(".sl-inside-prod-section");
        var item = head.closest("[data-feature-item]");
        if (!item) return;

        var featurePhoto = section
          ? section.querySelector("[data-feature-photo] .sl-call-photo__bg")
          : null;
        var wasActive = item.classList.contains("is-active");

        section.querySelectorAll("[data-feature-item]").forEach(function (i) {
          i.classList.remove("is-active");
        });

        if (!wasActive) {
          item.classList.add("is-active");

          if (featurePhoto && item.dataset.featureImage) {
            featurePhoto.src = item.dataset.featureImage;
            featurePhoto.alt = item.dataset.featureAlt || "";
          }

          head.blur();
          scrollFeatureHeadIntoView(head);
        }
      });
    });
  }

  initInsideProductFeatures();

  /* ------------------------------------------------------ Call demo buttons */
  var declineBtn = document.querySelector(".sl-call-btn--decline");
  var acceptBtn = document.querySelector(".sl-call-btn--accept");
  var statusEl = document.querySelector(".sl-call-photo__status");
  if (acceptBtn && statusEl) {
    acceptBtn.addEventListener("click", function () {
      statusEl.textContent = "CONNECTED";
    });
  }
  if (declineBtn && statusEl) {
    declineBtn.addEventListener("click", function () {
      statusEl.textContent = "IS CALLING";
    });
  }

  /* ------------------------------------------------------ Moments carousel (sales landing) */
  function initSalesMomentsCarousel(track) {
    if (!track || track.dataset.momentsInit === "true") return;
    track.dataset.momentsInit = "true";

    var section = track.closest(".moments-section");
    var prev = section ? section.querySelector("[data-moments-prev]") : null;
    var next = section ? section.querySelector("[data-moments-next]") : null;
    var autoTimer = null;

    function getGap() {
      var gap = parseFloat(getComputedStyle(track).gap);
      return isNaN(gap) ? 31 : gap;
    }

    function getOriginalCards() {
      return Array.prototype.slice.call(track.querySelectorAll(".moment:not([data-moment-clone])"));
    }

    function ensureLoopClones() {
      if (track.dataset.momentsCloned === "true") return;
      var originals = getOriginalCards();
      if (!originals.length) return;

      originals.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute("data-moment-clone", "true");
        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
      });

      track.dataset.momentsCloned = "true";
    }

    function cardStep() {
      var originals = getOriginalCards();
      var card = originals[0] || track.querySelector(".moment");
      return card ? card.offsetWidth + getGap() : track.clientWidth * 0.8;
    }

    function loopWidth() {
      return getOriginalCards().length * cardStep();
    }

    function normalizeScrollPosition() {
      var width = loopWidth();
      if (width <= 0) return;
      if (track.scrollLeft >= width) {
        track.scrollLeft -= width;
      } else if (track.scrollLeft < 0) {
        track.scrollLeft += width;
      }
    }

    function scrollToOffset(targetLeft, smooth) {
      track.scrollTo({ left: targetLeft, behavior: smooth ? "smooth" : "auto" });
    }

    function scrollToCard(card, smooth) {
      if (!card) return;
      var targetLeft = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
      scrollToOffset(targetLeft, smooth);
    }

    function scrollNext() {
      ensureLoopClones();
      var width = loopWidth();
      if (!width) return;

      var step = cardStep();
      var nextLeft = track.scrollLeft + step;

      if (nextLeft >= width) {
        scrollToOffset(nextLeft - width, false);
        requestAnimationFrame(function () {
          scrollToOffset(track.scrollLeft + step, true);
        });
        return;
      }

      scrollToOffset(nextLeft, true);
    }

    function scrollPrev() {
      ensureLoopClones();
      var width = loopWidth();
      if (!width) return;

      var step = cardStep();
      var nextLeft = track.scrollLeft - step;

      if (nextLeft < 0) {
        scrollToOffset(width, false);
        requestAnimationFrame(function () {
          scrollToOffset(width - step, true);
        });
        return;
      }

      scrollToOffset(nextLeft, true);
    }

    function startAuto() {
      if (autoTimer) return;
      autoTimer = window.setInterval(scrollNext, 5000);
    }

    function stopAuto() {
      window.clearInterval(autoTimer);
      autoTimer = null;
    }

    function resetAuto() {
      stopAuto();
      startAuto();
    }

    function initDesktopCarousel() {
      ensureLoopClones();
      var originals = getOriginalCards();
      var startCard = originals.length > 1 ? originals[1] : originals[0];
      scrollToCard(startCard, false);
      startAuto();
    }

    track.addEventListener("scroll", function () {
      window.requestAnimationFrame(normalizeScrollPosition);
    }, { passive: true });

    if (next) next.addEventListener("click", function () { stopAuto(); scrollNext(); resetAuto(); });
    if (prev) prev.addEventListener("click", function () { stopAuto(); scrollPrev(); resetAuto(); });

    track.addEventListener("mouseenter", stopAuto);
    track.addEventListener("mouseleave", startAuto);
    track.addEventListener("touchstart", stopAuto, { passive: true });
    track.addEventListener("touchend", function () { window.setTimeout(startAuto, 2000); }, { passive: true });

    initDesktopCarousel();
  }

  function initAllSalesMomentsCarousels(root) {
    (root || document).querySelectorAll(".sl-section.moments-section [data-moments]").forEach(initSalesMomentsCarousel);
  }

  initAllSalesMomentsCarousels();

  document.addEventListener("shopify:section:load", function (event) {
    initInsideProductFeatures(event.target);
    initAllSalesMomentsCarousels(event.target);
  });
})();
